module.exports = __webpack_public_path__ + "img/h1.21e1f907.jpg";